/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { mcpRegisterPost } from '../fn/asp-net-backend-api/mcp-register-post';
import { McpRegisterPost$Params } from '../fn/asp-net-backend-api/mcp-register-post';
import { wellKnownOauthAuthorizationServerGet } from '../fn/asp-net-backend-api/well-known-oauth-authorization-server-get';
import { WellKnownOauthAuthorizationServerGet$Params } from '../fn/asp-net-backend-api/well-known-oauth-authorization-server-get';
import { wellKnownOauthAuthorizationServerMcpGet } from '../fn/asp-net-backend-api/well-known-oauth-authorization-server-mcp-get';
import { WellKnownOauthAuthorizationServerMcpGet$Params } from '../fn/asp-net-backend-api/well-known-oauth-authorization-server-mcp-get';
import { wellKnownOauthProtectedResourceGet } from '../fn/asp-net-backend-api/well-known-oauth-protected-resource-get';
import { WellKnownOauthProtectedResourceGet$Params } from '../fn/asp-net-backend-api/well-known-oauth-protected-resource-get';
import { wellKnownOauthProtectedResourceMcpGet } from '../fn/asp-net-backend-api/well-known-oauth-protected-resource-mcp-get';
import { WellKnownOauthProtectedResourceMcpGet$Params } from '../fn/asp-net-backend-api/well-known-oauth-protected-resource-mcp-get';

@Injectable({ providedIn: 'root' })
export class AspNetBackendApiService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `wellKnownOauthProtectedResourceGet()` */
  static readonly WellKnownOauthProtectedResourceGetPath = '/.well-known/oauth-protected-resource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wellKnownOauthProtectedResourceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthProtectedResourceGet$Response(params?: WellKnownOauthProtectedResourceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = wellKnownOauthProtectedResourceGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wellKnownOauthProtectedResourceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthProtectedResourceGet(params?: WellKnownOauthProtectedResourceGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.wellKnownOauthProtectedResourceGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `wellKnownOauthProtectedResourceMcpGet()` */
  static readonly WellKnownOauthProtectedResourceMcpGetPath = '/.well-known/oauth-protected-resource/mcp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wellKnownOauthProtectedResourceMcpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthProtectedResourceMcpGet$Response(params?: WellKnownOauthProtectedResourceMcpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = wellKnownOauthProtectedResourceMcpGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wellKnownOauthProtectedResourceMcpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthProtectedResourceMcpGet(params?: WellKnownOauthProtectedResourceMcpGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.wellKnownOauthProtectedResourceMcpGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `wellKnownOauthAuthorizationServerGet()` */
  static readonly WellKnownOauthAuthorizationServerGetPath = '/.well-known/oauth-authorization-server';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wellKnownOauthAuthorizationServerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthAuthorizationServerGet$Response(params?: WellKnownOauthAuthorizationServerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = wellKnownOauthAuthorizationServerGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wellKnownOauthAuthorizationServerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthAuthorizationServerGet(params?: WellKnownOauthAuthorizationServerGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.wellKnownOauthAuthorizationServerGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `wellKnownOauthAuthorizationServerMcpGet()` */
  static readonly WellKnownOauthAuthorizationServerMcpGetPath = '/.well-known/oauth-authorization-server/mcp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wellKnownOauthAuthorizationServerMcpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthAuthorizationServerMcpGet$Response(params?: WellKnownOauthAuthorizationServerMcpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = wellKnownOauthAuthorizationServerMcpGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wellKnownOauthAuthorizationServerMcpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wellKnownOauthAuthorizationServerMcpGet(params?: WellKnownOauthAuthorizationServerMcpGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.wellKnownOauthAuthorizationServerMcpGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mcpRegisterPost()` */
  static readonly McpRegisterPostPath = '/mcp/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mcpRegisterPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  mcpRegisterPost$Response(params?: McpRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mcpRegisterPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mcpRegisterPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mcpRegisterPost(params?: McpRegisterPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.mcpRegisterPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
